/*
 * SANBY カートAPI（Shopify Ajax Cart API ラッパー）
 * 移植元: production/src/assets/js/utils.js の getCart/setCart/cartCount（localStorageモック）を置換。
 * 旧実装と同じ "sanby:cart-updated" イベントを、実際のカート操作の後に発火する。
 * イベントのdetailは旧実装の独自配列ではなく、Shopify標準の cart オブジェクト
 *（https://shopify.dev/docs/api/ajax/reference/cart 参照）そのものになる点に注意
 *（chrome.js/page-cart.jsは合わせてcart.items/cart.item_count等を参照する形に更新済み）。
 */
window.SANBY = window.SANBY || {};

(function (SANBY) {
  function dispatchCartUpdated(cart) {
    document.dispatchEvent(new CustomEvent("sanby:cart-updated", { detail: cart }));
    return cart;
  }

  function request(url, options) {
    return fetch(url, {
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      ...options,
    }).then((res) => {
      if (!res.ok) {
        return res.json().then((body) => {
          throw new Error((body && body.description) || `カートAPIエラー: ${res.status}`);
        });
      }
      return res.json();
    });
  }

  // 現在のカート内容を取得する（GET /cart.js）
  function getCart() {
    return request("/cart.js", { method: "GET" });
  }

  // 商品をカートに追加する（POST /cart/add.js）
  // id: variant ID（数値）, quantity: 数量, properties: line item properties（書体・お名前等、任意）
  //
  // propertiesの値にFile（版下エディタの版下画像等、実ファイル）が1つでも含まれる場合は
  // FormData送信に切り替える。JSON.stringifyはFileを表現できないが、Shopifyの/cart/add.jsは
  // multipart/form-data送信であればAjax（ページ遷移なし）のままファイルアップロードを
  // 受け付ける仕様（2026-09-04確認。Content-Typeヘッダーは自分で設定せず、ブラウザに
  // multipartの境界を自動生成させる必要がある）。この場合はJSON版の「items配列で複数一括」
  // 形式ではなく、id/quantity/properties[key]のフラットな単一アイテム形式になる
  // （/cart/add.jsが両方の形式をサポートしているが、multipart送信は単一アイテムのみ対応のため）。
  function addItem({ id, quantity = 1, properties } = {}) {
    if (!id) return Promise.reject(new Error("addItem: variant idが指定されていません"));

    const hasFile = properties && Object.values(properties).some((v) => v instanceof File);
    if (hasFile) {
      const formData = new FormData();
      formData.append("id", id);
      formData.append("quantity", quantity);
      Object.entries(properties).forEach(([key, val]) => {
        if (val !== undefined && val !== null) formData.append(`properties[${key}]`, val);
      });
      return fetch("/cart/add.js", { method: "POST", credentials: "same-origin", body: formData })
        .then((res) => {
          if (!res.ok) {
            return res.json().then((body) => {
              throw new Error((body && body.description) || `カートAPIエラー: ${res.status}`);
            });
          }
          return res.json();
        })
        .then(() => getCart().then(dispatchCartUpdated));
    }

    return request("/cart/add.js", {
      method: "POST",
      body: JSON.stringify({ items: [{ id, quantity, properties }] }),
    }).then(() => getCart().then(dispatchCartUpdated));
  }

  // カート内の商品の数量を変更する（POST /cart/change.js）。quantity: 0で削除と同義。
  // key: cart.items[].key（line item property違いでも一意に特定できる、variant idより堅牢）
  function updateItemQuantity(key, quantity) {
    return request("/cart/change.js", {
      method: "POST",
      body: JSON.stringify({ id: key, quantity }),
    }).then(dispatchCartUpdated);
  }

  function removeItem(key) {
    return updateItemQuantity(key, 0);
  }

  // カート内アイテムの合計数量（ヘッダーバッジ表示用）
  function itemCount(cart) {
    return cart ? cart.item_count : 0;
  }

  SANBY.cartApi = {
    getCart,
    addItem,
    updateItemQuantity,
    removeItem,
    itemCount,
  };
})(window.SANBY);
